const ROUTES = {
    // Auth
    LOGIN: "/auth",
    VERIFY: "/verify",
    RESET_PASSWORD: "/reset-password",

    // Main views
    DOMAIN_CONFIGURATION: "domain-configuration",
    DEPLOYMENT_MANAGEMENT: "deployment-management",
    RUNTIME_CONFIG: "runtime-config",
    BUILD_TIME_CONFIG: "build-time-config",
    NOTIFICATIONS: "notifications",
    SITE_MONITORING: "site-monitoring",
    SUPPORT_LOGS: "support-logs",
    USERS: "users",
    PRODUCTS: "products",
    DOMAIN_LOGS: "domain-logs",
    ENVIRONMENT_TEMPLATES: "environment-templates",
    AUDIT_TRAIL: "audit-trail",
    DOMAINS: "domains",
    SETTINGS_COMPARISON: "settings-comparison",
    ENVIRONMENTS: "environments",
    EMAIL_MANAGEMENT: "email-management",
    DOWNLOADABLES: "downloadables",
    AI_PIPELINES: "ai-pipelines",
    LANDING: "/",
};

export default ROUTES;
